<template>
  <!-- Header der Kalenderansicht -->
  <div id="header">
    <div id="frame">
      <comline-logo v-if="header === `web`" :fill="'#fff'" :height="'40px'" :width="'40px'" id="logo" />
      <p>ChargeLine</p>
      <div id="charges">
        <!--shows how many bookings the user has available-->
        <img src="../assets/bolt.svg" alt="Charges" id="bolt" />
        <span style="margin-top: 3px"> X {{ bookingCount }}</span>
      </div>
      <button @click="logOut">
        <!-- Icon of logout -->
        <img
          style="width: 35px; margin-top: 4px"
          src="../assets/logout.svg"
          alt="Logout"
        />
      </button>
    </div>
  </div>
</template>

<script>
import ComlineLogo from "../assets/ComlineLogo.vue";
import { auth } from "../plugins/firebase/index";
import { signOut } from "firebase/auth";
import { Capacitor } from '@capacitor/core';

export default {
  props: {
    bookingCount: Number,
  },
  components: {
    ComlineLogo,
  },
  methods: {
    logOut() {
      //user will be log out
      signOut(auth)
        .then(() => {
          // Sign-out successful.
          // navigate to login page
          this.$router.replace({ name: "login" });
        })
        .catch((error) => {
          // An error happened.
          console.log(error);
        });
    },
  },
  data() {
    return {
      header: "",
    }
  },
  mounted() {

    this.header = Capacitor.getPlatform()
    // visualizes depleation of bookings
    // when no bookings available, color is red
    if (this.bookingCount === 0) {
      document.getElementById("charges").style.color = "red";
    } else {
      document.getElementById("charges").style.color = "black";
    }
  },
};
</script>

<style scoped>
#header {
  padding-top: env(safe-area-inset-top);
  background-color: #4089c9;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1999;
}
#frame {
  max-width: 1200px;
  margin: auto;
  display: flex;
  align-items: center;
}
#logo {
  margin-left: 10px;
}
#header p {
  color: #fff;
  font-size: 1.5em;
  font-weight: bold;
  margin: 10px 20px;
}
#charges {
  height: 40px;
  margin-left: auto;
  margin-right: 35px;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 10px;
}
button {
  margin-right: 10px;
  border: none;
  font-size: 1.1rem;
  background-color: transparent;
}
#month {
  position: relative;
  text-align: start;
  margin: 20px 15px 30px;
  top: 15px;
  font-size: 2rem;
}
.charge:first-of-type {
  border-radius: 8px 0 0 8px;
}
.charge:last-of-type {
  border-radius: 0 8px 8px 0;
}
#bolt {
  height: 70%;
  margin-right: 5px;
}
</style>